/**
 * Reusable confirmation modal for admin destructive actions.
 * Renders under an existing z-index stack — pass zClass to override placement.
 */
const ConfirmModal = ({
  open,
  title,
  description,
  confirmLabel,
  onCancel,
  onConfirm,
  busy = false,
  variant = 'danger',
  zClass = 'z-[70]',
  testId
}) => {
  if (!open) return null;

  const confirmClass = variant === 'danger'
    ? 'bg-red-600 hover:bg-red-700'
    : variant === 'warning'
      ? 'bg-orange-600 hover:bg-orange-700'
      : 'bg-green-600 hover:bg-green-700';

  return (
    <div className={`fixed inset-0 bg-black/50 backdrop-blur-sm ${zClass} flex items-center justify-center p-4`}>
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full shadow-2xl" data-testid={testId}>
        <h2 className="text-lg font-bold text-gray-900 mb-2">{title}</h2>
        {description && <p className="text-sm text-gray-600 mb-4">{description}</p>}
        <div className="flex gap-2">
          <button
            onClick={onCancel}
            className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 px-4 py-2.5 rounded-xl text-sm font-semibold"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={busy}
            className={`flex-1 text-white px-4 py-2.5 rounded-xl text-sm font-semibold disabled:opacity-50 ${confirmClass}`}
            data-testid={testId ? `${testId}-confirm-btn` : undefined}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
